module.exports = {
  mountPoint: "dhl-cj-ots",
  appShortName: "ots",
  appName: "one-time-shipment",
};
